import { Item, RenderItemFormSidebarPanelCtx } from "datocms-plugin-sdk";
import { Canvas, TextInput, Button } from "datocms-react-ui";
import { useState } from "react";

type Props = {
  ctx: RenderItemFormSidebarPanelCtx,
};

function DialogToolbar({ ctx }: Props) {
  const itemId = ctx.item?.id ?? "";
  return (
    <Canvas ctx={ctx}>
      <div>

        <Button 
          onClick={() => {
          ctx.openModal({
            id: 'renderDialogEditor',
            title: 'Dialog Editor',
            width: 'l',
            parameters: {
              id: itemId,
              dialogContent: ctx.formValues,
            },
          });
        }}>Open dialog editor</Button>
      </div>
    </Canvas>
  );
};

export default DialogToolbar;